import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import App from "./App";
import { authConfig } from "./auth/authConfig";
import { MockAuthProvider } from "./auth/MockAuthProvider";
import "./index.css";

const skipAuth = process.env.REACT_APP_SKIP_AUTH === "true";

const onSigninCallback = () => {
  window.history.replaceState({}, document.title, "/login");
};

// After Cognito redirects back post-logout, send user to /login cleanly.
const onSignoutCallback = () => {
  window.location.replace(window.location.origin + "/login");
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  skipAuth ? (
    <MockAuthProvider>
      <App />
    </MockAuthProvider>
  ) : (
    <AuthProvider
      {...authConfig}
      onSigninCallback={onSigninCallback}
      onSignoutCallback={onSignoutCallback}
    >
      <App />
    </AuthProvider>
  )
);
